module.exports = "/images/mg.svg?55c2e9427b10d486dd5b3ddc4a76b298";